﻿// @ts-nocheck
// initialization (entry)

// ========== Initialization ==========
renderApp();

